import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { IDatePickerConfig, IDatePickerToastText } from "mis-crystal-design-system/datepicker_v2";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { parseZone, min } from "moment";
import { take } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "mis-employee-web-exp-recurrence-booking-form",
  templateUrl: "./recurrence-booking-form.component.html",
  styleUrls: ["./recurrence-booking-form.component.scss"]
})
export class RecurrenceBookingFormComponent implements OnInit {
  @Input() dpConfig: Partial<IDatePickerConfig>;
  @Input() datesDisabled: string[];
  @Input() dateMessages: IDatePickerToastText[];
  @Input() recurrenceFormGroup: FormGroup;
  @Input() maxDuration: number;
  @Input() weeklyOffs: number[] = [];
  @Output() recurrenceForm = new EventEmitter<FormGroup>();

  errorInput = false;
  disableDay = false;
  private endObs = new Subject<void>();
  days: string[] = ["M", "T", "W", "T", "F", "S", "S"];
  daysIndex: number[] = [1, 2, 3, 4, 5, 6, 7];
  selectedDays: Set<number> = new Set();
  premiseForm: FormGroup = this.fb.group({});
  selectedOption: number = -1;
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (this.weeklyOffs.length) {
      this.weeklyOffs = this.weeklyOffs.map(item => {
        if (item === 1) item = 7;
        else item = item - 1;
        return item;
      });
    }
    this.recurrenceFormGroup = this.recurrenceFormGroup.controls.recurrence as FormGroup;
    this.dpConfig.minDate = parseZone(this.dpConfig.minDate).tz(this.dpConfig.timezone).format(this.dpConfig.format);
    this.recurrenceFormGroup = this.buildingForm();
    this.radioEventHandler(0); // for initial selection of first radio button
    this.recurrenceFormGroup.controls.endDate.valueChanges.pipe(take(1)).subscribe(changedDate => {
      this.recurrenceFormGroup.get("endDate").patchValue(changedDate);
      this.emitFormData();
    });
  }
  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }
  buildingForm(): FormGroup {
    const today = parseZone().tz(this.dpConfig.timezone);
    const nextMonth = today.add(1, "month");
    const maxDate = parseZone(this.dpConfig.maxDate).tz(this.dpConfig.timezone);
    const endDate = min(nextMonth, maxDate).format(this.dpConfig.format);

    const form = new FormGroup({
      recurrenceVisibility: new FormControl(true),
      endDate: new FormControl(endDate || undefined, Validators.required),
      repeatsEvery: new FormGroup({
        days: new FormControl([], []),
        repeatedDay: new FormControl({ value: 1, disabled: true }, [Validators.required, Validators.max(this.maxDuration), Validators.min(1)])
      })
    });
    return form;
  }
  toggleWorkingDay(day: number): void {
    if (this.selectedDays.has(day)) {
      this.selectedDays.delete(day);
    } else if (!this.weeklyOffs.includes(day)) {
      this.selectedDays.add(day);
      this.disableDay = false;
    } else {
      this.disableDay = true;
    }
    this.recurrenceFormGroup.get("repeatsEvery").patchValue({ days: Array.from(this.selectedDays) }, { onlySelf: false });
    this.emitFormData();
  }
  radioEventHandler(id: number) {
    const repeatsEvery = this.recurrenceFormGroup.controls.repeatsEvery as FormGroup;
    this.selectedOption = id;
    if (this.selectedOption === 1) {
      repeatsEvery.get("repeatedDay").enable();
      repeatsEvery.get("days").disable();
    } else {
      repeatsEvery.get("repeatedDay").disable();
      repeatsEvery.get("days").enable();
    }
    this.emitFormData();
  }
  emitFormData(fromInput?: string) {
    if (fromInput && fromInput.length > 0) {
      const repeatedDay = (this.recurrenceFormGroup.controls.repeatsEvery as FormGroup).controls.repeatedDay;
      repeatedDay.status === "VALID" && this.recurrenceForm.emit(this.recurrenceFormGroup);
      this.errorInput = repeatedDay.status === "INVALID" ? true : false;
    } else this.recurrenceForm.emit(this.recurrenceFormGroup);
  }
}
